<template>
	<div class="footer">

		<div class="w cle">
			<div class="he">
				<div class="it">
				<router-link to='/home'>
					<a href="#" class="li_a">
						Home
					</a>
				</router-link>
				</div>
				<div class="it">
					<router-link to='/proudct'>
						<a href="#" class="li_a">
							Products
						</a>
					</router-link>
				</div>
				<div class="it">
					<router-link to='/about'>
						<a href="#" class="li_a">
							About US
						</a>
						</router-link>
				</div>
			</div>

			<div class="f_logo">

				<a href="#">
					<img src="../../static/img25.jpg" />
				</a>

				<div class="dects">
          LocTok is a platform that helps consumers find the products they need quickly and freely

				</div>

			</div>

			<div class="share">

				<a href="https://www.facebook.com/Loctokservice/" target="_blank">
					<img src="../../static/p48.png"  style="width: 30px;"/>
				</a>
				<span class="common_pc_show">
					<a href="https://web.whatsapp.com/send?phone=+1(720)722-0502" target="_blank">
						<img src="../../static/p47.png" style="width: 27px;" />
					</a>
				</span>
				<span class="common_phone_show">
					<a href="whatsapp://send?phone=+1(720)722-0502" target="_blank">
						<img src="../../static/p47.png" style="width: 27px;" />
					</a>
				</span>
				<a href="https://twitter.com/LoctokS" target="_blank">
					<img src="../../static/p46.png"  style="width: 30px;" />
				</a>
				<a href="https://www.instagram.com/loctok_test/" target="_blank" >
					<img src="../../static/p42.png" style="width: 30px;" />
				</a>
				<a href="mailto:loctok013@gmail.com">
					<img src="../../static/p44.png"  style="width: 30px;"/>
				</a>

			</div>

		</div>

<div class="copy">&copy;Copyrights 2021<span> LocTok</span> All rights reserved. Sitemap</div>

	</div>
</template>

<script>
	export default {
		name: 'Footer',
		props: {
			msg: String
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.footer {
		background: #05171b;
		padding: 30px 0 0;
		border-top: 8px solid #242b66;
	}

	.footer .he {
		border-bottom: 1px solid #878787;
		display: flex;
		padding-bottom: 15px;
		margin-bottom: 30px;
	}

	.footer .he .it {
		flex: 1;
		text-align: center;
		font-size: 16px;
		color: #ffffff;
		font-family: '微软雅黑';
	}

	.footer .he .it a {
		color: #fff;
	}

	.footer .f_logo {
		text-align: center;
	}

	.footer .f_logo .dects {
		margin: 15px 0;
		color: #fff;
		font-size: 12px;
		line-height: 25px;
	}

	.footer .share {
		text-align: center;
	}
	.footer .share  a{
		margin: 0px 4px;
	}
	 
	.footer .copy{
		text-align: center;
		font-size: 12px;
		color: #818181;
		background: #000000;
		padding: 20px 0;
		margin-top: 15px;
	}
	.footer .copy span{
		color: #fff;
	}
</style>
